import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule} from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { LoginComponent } from './login/login.component';
import { ResetComponent, ResetType } from './reset/reset.component';

import { SocialLoginModule,  GoogleLoginProvider, FacebookLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { TempAuthService } from '../services/tempAuthService';
import { UUIDService } from '../services/uuid.service';
import { CommonService } from 'huddyapi';
import { DirectivesModule } from '../directives/directive.module';
import { DirectAccessGuard } from '../guards/directAccess.guard';
import { LoginGuard } from '../guards/login.guard';
import { MatSelectModule } from '@angular/material/select';
import { PrivacySnackBarModule } from './privacy-snack-bar/privacy-snack-bar.module';
const config : SocialAuthServiceConfig = ({
  autoLogin: false,
  lang: 'en',
 providers: [ {
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider('5360163219-o2aqgbsbgc3jeskjn0udmduc198c20ub.apps.googleusercontent.com')
    },
    {
      id: FacebookLoginProvider.PROVIDER_ID,
      provider: new FacebookLoginProvider('1758997887499031')
    }
  ]
});
export function provideConfig() {
  return config;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    SocialLoginModule,
    DirectivesModule,
    PrivacySnackBarModule,
    RouterModule.forChild([
      {
        path: 'login',
        canActivate: [LoginGuard],
        component: LoginComponent,
        children: []
      },
      {
        path: 'reset',
        data: { type: ResetType.RESET_PASSWORD },
        canActivate: [LoginGuard],
        component: ResetComponent,
        children: []
      },
      {
        path: 'reset/:email',
        data: { type: ResetType.RESET_PASSWORD },
        canActivate: [DirectAccessGuard, LoginGuard],
        component: ResetComponent,
        children: []
      },
      {
        path: 'complete',
        data: { type: ResetType.COMPLETE_REGISTRATION },
        canActivate: [LoginGuard],
        component: ResetComponent,
        children: []
      }
    ])
  ],
  declarations: [
    LoginComponent,
    ResetComponent
  ],
  exports: [
    LoginComponent,
    ResetComponent
  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useFactory: provideConfig
    },
    TempAuthService,
    UUIDService,
    CommonService
  ]
})
export class UserManagementModule { }
